import Recipients from './RecipientsContainer';

export default Recipients

